import { httpRequest } from "@services/http";
import { legacyDashboardUrl } from "@/modules/opLaunchPages/services/legacyDashboardUrl";
import type { ReportSummary } from "../models";

export class CommandListReports {
    async run(): Promise<ReportSummary[]> {
        return await httpRequest<ReportSummary[]>(legacyDashboardUrl("reports/").toString());
    }
}
